import classNames from 'classnames';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import HeroesIcon from 'app/components/HeroesIcon';

import style from './style.module.scss';

interface Props extends ClassNameProp {
  videogame: 'dota2' | 'lol';
  opponent1PicksAndbans?: { most_picked: HeroStat[]; most_banned_against: HeroStat[] };
  opponent2PicksAndbans?: { most_picked: HeroStat[]; most_banned_against: HeroStat[] };
}

const PicksAndBans: FC<Props> = ({
  opponent1PicksAndbans,
  opponent2PicksAndbans,
  className,
  videogame
}) => {
  const { t } = useTranslation();

  return (
    <div className={classNames(style.heroesLinesContainer, className)}>
      <div className={style.pickedHeroes}>
        <h3 className={style.heroesTitleMobile}>{t('component_heroes_most-picked')}</h3>
        <div className={style.heroesLine}>
          <HeroesIcon
            heroes={opponent1PicksAndbans?.most_picked ?? []}
            iconClassName={style.heroIcon}
            heroClassName={style.hero}
            containerClassName={style.heroesContainer}
            shiftImages
            videogame={videogame}
            placeholderSize={3}
          />
          <h3 className={style.heroesTitleTablet}>{t('component_heroes_most-picked')}</h3>
          <HeroesIcon
            heroes={opponent2PicksAndbans?.most_picked ?? []}
            iconClassName={style.heroIcon}
            orientation="reversed"
            heroClassName={style.hero}
            containerClassName={style.heroesContainer}
            shiftImages
            videogame={videogame}
            placeholderSize={3}
          />
        </div>
      </div>
      <div className={style.bannedHeroes}>
        <h3 className={style.heroesTitleMobile}>{t('component_heroes_most-banned-against')}</h3>
        <div className={style.heroesLine}>
          <HeroesIcon
            heroes={opponent1PicksAndbans?.most_banned_against ?? []}
            iconClassName={classNames(style.heroIcon, style.bannedHero)}
            heroClassName={style.hero}
            containerClassName={style.heroesContainer}
            shiftImages
            type="ban"
            videogame={videogame}
            placeholderSize={3}
          />
          <h3 className={style.heroesTitleTablet}>{t('component_heroes_most-banned-against')}</h3>
          <HeroesIcon
            heroes={opponent2PicksAndbans?.most_banned_against ?? []}
            iconClassName={classNames(style.heroIcon, style.bannedHero)}
            orientation="reversed"
            heroClassName={style.hero}
            containerClassName={style.heroesContainer}
            shiftImages
            type="ban"
            videogame={videogame}
            placeholderSize={3}
          />
        </div>
      </div>
    </div>
  );
};

PicksAndBans.displayName = 'PicksAndBans';

export default PicksAndBans;
